/**
 * @fileoverview GET handler for the "/admin/impersonation" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { adminImpersonation } from "./constants";
import type { AdminImpersonationResult } from "./types";

export const getAdminImpersonation = reactQueryFetcherAdapter(
  adminImpersonation,
  (signal: AbortSignal, query: string, limit: number): Promise<AdminImpersonationResult> => {
    return fetch("/admin/impersonation", "GET", { query, limit }, { signal });
  }
);
